import { createFileRoute } from "@tanstack/react-router";
import AudioIconPlayer from "@/components/tools/Polly/AudioIconPlayer.tsx";

export const Route = createFileRoute("/feed")({
  component: RouteComponent,
});

// function RouteComponent() {
//   return <Feed />;
// }

function RouteComponent() {
  return <ArticleComponent />;
}

export const ArticleComponent: React.FC = () => {
  return (
    <div className="article p-4">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-bold">Titre de l'article</h2>
        <AudioIconPlayer text="Titre de l'article" size="sm" />
      </div>

      <div className="paragraph mb-4 relative">
        <p>
          Ceci est un paragraphe d'exemple qui pourrait être lu à haute voix. Le
          lecteur audio peut être placé n'importe où dans votre interface.
        </p>
        <div className="absolute right-0 top-0">
          <AudioIconPlayer text="Ceci est un paragraphe d'exemple qui pourrait être lu à haute voix. Le lecteur audio peut être placé n'importe où dans votre interface." />
        </div>
      </div>

      <div className="info-card bg-base-200 p-4 rounded-lg relative">
        <h3 className="font-bold flex items-center">
          Information importante
          <AudioIconPlayer
            text="Information importante. Ce bloc contient des informations essentielles pour les utilisateurs."
            size="sm"
            className="ml-2"
          />
        </h3>
        <p>
          Ce bloc contient des informations essentielles pour les utilisateurs.
        </p>
      </div>
    </div>
  );
};
